import { List, Typography, Box, CircularProgress } from '@mui/joy'
import { useUsers } from '../../../hooks/user/useUsers'
import PersonShow from '../PersonShow/PersonShow'
import ServerError, { NotFound } from '../ServerError/ServerError';
import ShowMoreButton from './ShowMoreButton';

// Поиск показывает только самые релевантные совпадения — без бесконечной ленты
const MAX_RESULTS = 5;

function ListShow({ results = [], hasMore, loadingMore, loadMore }) {
    return (
        <>
            <List>
                {results.map((user, index) => <PersonShow user={user} key={user?.id ?? index} />)}
            </List>
            {hasMore && (
                <ShowMoreButton count={MAX_RESULTS} loading={loadingMore} onClick={loadMore} />
            )}
        </>
    )
}

function UserResults({ query }) {
    const search = (query ?? '').trim();
    const hasQuery = search.length > 0;

    const { users, error, loading, hasMore, loadingMore, loadMore } = useUsers(search, { limit: MAX_RESULTS, enabled: hasQuery });

    const results = Array.isArray(users) ? users : [];

    if (!hasQuery) {
        return (
            <NotFound
                img="no-messages.svg"
                title="Начните вводить запрос"
                desc="Введите имя, фамилию или логин, чтобы найти пользователя"
            />
        )
    }

    return (
        <>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : error ? (
                <ServerError />
            ) : users ? (
                <>
                    {results.length > 0 ? (
                        <ListShow
                            results={results}
                            hasMore={hasMore}
                            loadingMore={loadingMore}
                            loadMore={loadMore}
                        />
                    ) : (
                        <NotFound title="Пользователи не найдены" />
                    )}
                </>
            ) : null}
        </>
    )
}

export default UserResults
